import { Base64 } from './base64'
import { MailParser } from './mailParser'

/*
    mime-js.js 0.2.0
    2014-10-18

    By Ikrom, https://github.com/ikr0m
    License: X11/MIT
 */

export const Mime = function () {
    let buildMimeObj, toMimeObj, toMimeTxt, _util;
    const domain = '@mail.gmail.com>'
    toMimeTxt = function (mail, txtOnly) {
        var alternative, attaches, cids, createAlternative, createAttaches, createCids, createHtml, createMixed, createPlain, createRelated, getBoundary, htm, linkify, plain, related, result;
        linkify = function (inputText) {
            var replacePattern1, replacePattern2, replacePattern3, replacedText;
            replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            replacedText = inputText.replace(replacePattern1, "<a href=\"$1\" target=\"_blank\">$1</a>");
            replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            replacedText = replacedText.replace(replacePattern2, "$1<a href=\"http://$2\" target=\"_blank\">$2</a>");
            replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
            replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
            return replacedText;
        };
        getBoundary = function () {
            var _random;
            _random = function () {
                return Math.random().toString(36).slice(2);
            };
            return _random() + _random();
        };
        createPlain = function (textContent) {
            if (textContent == null) {
                textContent = '';
            }
            return '\nContent-Type: text/plain; charset=UTF-8' + '\nContent-Transfer-Encoding: base64' + '\n\n' + (Base64.encode(textContent, true)).replace(/.{76}/g, "$&\n");
        };
        createHtml = function (msg) {
            var htmlContent;
            htmlContent = msg.body || "";
            // htmlContent = htmlContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/, '&gt;').replace(/\n/g, '\n<br/>');
            // htmlContent = linkify(htmlContent);
            htmlContent = '<div>' + htmlContent + '</div>';
            return '\nContent-Type: text/html; charset=UTF-8' + '\nContent-Transfer-Encoding: base64' + '\n\n' + (Base64.encode(htmlContent, true)).replace(/.{76}/g, "$&\n");
        };
        createAlternative = function (text, html) {
            var boundary;
            boundary = getBoundary();
            // return '\nContent-Type: multipart/alternative; boundary=' + boundary + '\n\n--' + boundary + text + '\n\n--' + boundary + html + '\n\n--' + boundary + '--';
            return '\nContent-Type: multipart/alternative; boundary=' + boundary + '\n\n--' + boundary + html + '\n\n--' + boundary + '--';
        };
        createCids = function (cids) {
            var base64, cid, cidArr, id, name, type, _i, _len;
            if (!cids) {
                return;
            }
            cidArr = [];
            for (_i = 0, _len = cids.length; _i < _len; _i++) {
                cid = cids[_i];
                type = cid.type;
                name = cid.name;
                base64 = cid.base64;
                id = getBoundary();
                cidArr.push('\nContent-Type: ' + type + '; name=\"' + name + '\"' + '\nContent-Transfer-Encoding: base64' + '\nContent-ID: <' + id + '>' + '\nX-Attachment-Id: ' + id + '\n\n' + base64);
            }
            return cidArr;
        };
        createRelated = function (alternative, cids) {
            var boundary, cid, relatedStr, _i, _len;
            if (cids == null) {
                cids = [];
            }
            boundary = getBoundary();
            relatedStr = '\nContent-Type: multipart/related; boundary=' + boundary + '\n\n--' + boundary + alternative;
            for (_i = 0, _len = cids.length; _i < _len; _i++) {
                cid = cids[_i];
                relatedStr += '\n--' + boundary + cid;
            }
            return relatedStr + '\n--' + boundary + '--';
        };
        createAttaches = function (attaches) {
            var attach, base64, id, name, result, type, _i, _len;
            if (!attaches) {
                return;
            }
            result = [];
            for (_i = 0, _len = attaches.length; _i < _len; _i++) {
                attach = attaches[_i];
                type = attach.type || attach.mime || attach.mimeType;
                name = attach.name;
                base64 = attach.base64;
                id = getBoundary();
                result.push('\nContent-Type: ' + type + '; name=\"' + name + '\"' + '\nContent-Disposition: attachment; filename=\"' + name + '\"' + '\nContent-Transfer-Encoding: base64' + '\nX-Attachment-Id: ' + id + '\n\n' + base64);
            }
            return result;
        };
        createMixed = function (related, attaches) {
            var attach, boundary, date, mailFromName, mimeStr, subject, _i, _len;
            let in_reply_to = '', message_id = '', references = ''
            boundary = getBoundary();
            subject = '';
            if (mail.subject) {
                subject = '=?UTF-8?B?' + Base64.encode(mail.subject, true) + '?=';
            }
            if(mail.message_id) {
                message_id = `\nMessage-ID: ${mail.message_id}`
            }else {
                message_id = '\nMessage-ID: <' + getBoundary() + domain
            }
            if(mail.in_reply_to) {
                in_reply_to = `\nIn-Reply-To: ${mail.in_reply_to}`
            }
            if(mail.references) {
                references = `\nReferences: ${mail.references}`
            }
            mailFromName = '=?UTF-8?B?' + Base64.encode(mail.fromName || "", true) + '?=';
            date = (new Date().toGMTString()).replace(/GMT|UTC/gi, '+0000');
            mimeStr = 'MIME-Version: 1.0' + '\nDate: ' + date + message_id + '\nSubject: ' + subject + '\nFrom: ' + mailFromName + ' <' + mail.from + '>' + (mail.to.length ? '\nTo: ' + mail.to : '') + (mail.cc.length ? '\nCc: ' + mail.cc : '') + (mail.bcc.length ? '\nBcc: ' + mail.bcc : '') + in_reply_to + references + '\nContent-Type: multipart/mixed; boundary=' + boundary + '\n\n--' + boundary + related;
            for (_i = 0, _len = attaches.length; _i < _len; _i++) {
                attach = attaches[_i];
                mimeStr += '\n--' + boundary + attach;
            }
            return (mimeStr + '\n--' + boundary + '--').replace(/\n/g, '\r\n');
        };
        plain = createPlain(mail.body);
        if (txtOnly) {
            related = plain;
        } else {
            htm = createHtml(mail);
            alternative = createAlternative(plain, htm);
            cids = createCids(mail.cids);
            related = createRelated(alternative, cids);
        }
        attaches = createAttaches(mail.attaches);
        result = createMixed(related, attaches);
        return result;
    };
    _util = (function () {
        var KOIRDec, QPDec, decode, decodeMimeWords, toHtmlEntity, trim, win1251Dec, _decodeMimeWord;
        trim = function (str) {
            if (str == null) {
                str = '';
            }
            return (typeof str.trim === "function" ? str.trim() : void 0) || str.replace(/^\s+|\s+$/g, '');
        };
        decode = function (txt, charset) {
            var result;
            if (txt == null) {
                txt = '';
            }
            if (charset == null) {
                charset = '';
            }
            charset = charset.toLowerCase();
            result = (function () {
                switch (false) {
                    case charset.indexOf('koi8-r') === -1:
                        return KOIRDec(txt);
                    case charset.indexOf('utf-8') === -1:
                        return Base64._utf8_decode(txt);
                    case charset.indexOf('windows-1251') === -1:
                        return win1251Dec(txt);
                    default:
                        return txt;
                }
            })();
            return result;
        };
        QPDec = function (s) {
            return s.replace(/\=[\r\n]+/g, "").replace(/\=[0-9A-F]{2}/gi, function (v) {
                return String.fromCharCode(parseInt(v.substr(1), 16));
            });
        };
        KOIRDec = function (str) {
            var charmap, code2char, i, res, val, _i, _len;
            charmap = unescape("%u2500%u2502%u250C%u2510%u2514%u2518%u251C%u2524%u252C%u2534%u253C%u2580%u2584%u2588%u258C%u2590" + "%u2591%u2592%u2593%u2320%u25A0%u2219%u221A%u2248%u2264%u2265%u00A0%u2321%u00B0%u00B2%u00B7%u00F7" + "%u2550%u2551%u2552%u0451%u2553%u2554%u2555%u2556%u2557%u2558%u2559%u255A%u255B%u255C%u255D%u255E" + "%u255F%u2560%u2561%u0401%u2562%u2563%u2564%u2565%u2566%u2567%u2568%u2569%u256A%u256B%u256C%u00A9" + "%u044E%u0430%u0431%u0446%u0434%u0435%u0444%u0433%u0445%u0438%u0439%u043A%u043B%u043C%u043D%u043E" + "%u043F%u044F%u0440%u0441%u0442%u0443%u0436%u0432%u044C%u044B%u0437%u0448%u044D%u0449%u0447%u044A" + "%u042E%u0410%u0411%u0426%u0414%u0415%u0424%u0413%u0425%u0418%u0419%u041A%u041B%u041C%u041D%u041E" + "%u041F%u042F%u0420%u0421%u0422%u0423%u0416%u0412%u042C%u042B%u0417%u0428%u042D%u0429%u0427%u042A");
            code2char = function (code) {
                if (code >= 0x80 && code <= 0xFF) {
                    return charmap.charAt(code - 0x80);
                }
                return String.fromCharCode(code);
            };
            res = "";
            for (i = _i = 0, _len = str.length; _i < _len; i = ++_i) {
                val = str[i];
                res = res + code2char(str.charCodeAt(i));
            }
            return res;
        };
        win1251Dec = function (str) {
            var i, iCode, oCode, result, s, _i, _len;
            if (str == null) {
                str = '';
            }
            result = '';
            for (i = _i = 0, _len = str.length; _i < _len; i = ++_i) {
                s = str[i];
                iCode = str.charCodeAt(i);
                oCode = (function () {
                    switch (false) {
                        case iCode !== 168:
                            return 1025;
                        case iCode !== 184:
                            return 1105;
                        case !((191 < iCode && iCode < 256)):
                            return iCode + 848;
                        default:
                            return iCode;
                    }
                })();
                result = result + String.fromCharCode(oCode);
            }
            return result;
        };
        _decodeMimeWord = function (str, toCharset) {
            var encoding, fromCharset, match;
            str = _util.trim(str);
            fromCharset = void 0;
            encoding = void 0;
            match = void 0;
            match = str.match(/^\=\?([\w_\-]+)\?([QqBb])\?([^\?]*)\?\=$/i);
            if (!match) {
                return decode(str, toCharset);
            }
            fromCharset = match[1];
            encoding = (match[2] || "Q").toString().toUpperCase();
            str = (match[3] || "").replace(/_/g, " ");
            if (encoding === "B") {
                return Base64.decode(str, toCharset);
            } else if (encoding === "Q") {
                return QPDec(str);
            } else {
                return str;
            }
        };
        decodeMimeWords = function (str, toCharset) {
            str = (str || "").toString().replace(/(=\?[^?]+\?[QqBb]\?[^?]+\?=)\s+(?==\?[^?]+\?[QqBb]\?[^?]*\?=)/g, "$1").replace(/\=\?([\w_\-]+)\?([QqBb])\?[^\?]*\?\=/g, (function (mimeWord, charset, encoding) {
                return _decodeMimeWord(mimeWord);
            }).bind(this));
            return decode(str, toCharset);
        };
        toHtmlEntity = function (txt) {
            if (txt == null) {
                txt = "";
            }
            return (txt + "").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        };
        return {
            decode: decode,
            KOIRDec: KOIRDec,
            win1251Dec: win1251Dec,
            decodeMimeWords: decodeMimeWords,
            toHtmlEntity: toHtmlEntity,
            trim: trim
        };
    })();
    buildMimeObj = function (rawMailObj) {
        var body, decodeBody, err, isHtml, isText, mergeInnerMsgs, mimeType, parseBodyParts, parts, readyMail, result, wrapPreTag;
        readyMail = {
            html: "",
            text: "",
            attaches: [],
            innerMsgs: [],
            to: _util.decodeMimeWords(rawMailObj.to),
            cc: _util.decodeMimeWords(rawMailObj.cc),
            from: _util.decodeMimeWords(rawMailObj.from),
            subject: _util.decodeMimeWords(rawMailObj.subject)
        };
        decodeBody = function (body, rawHeaders) {
            var decBody, isBase64, isQP;
            isQP = /Content-Transfer-Encoding: quoted-printable/i.test(rawHeaders);
            isBase64 = /Content-Transfer-Encoding: base64/i.test(rawHeaders);
            if (isBase64) {
                body = body.replace(/\s/g, '');
                decBody = typeof atob === "function" ? atob(body) : void 0;
                if (decBody == null) {
                    decBody = Base64.decode(body);
                }
                body = decBody;
            } else if (isQP) {
                body = _util.QPDec(body);
            }
            return body;
        };
        parseBodyParts = function (bodyParts) {
            var attach, body, innerMsg, isAttach, isAudio, isHtml, isImg, isPlain, isQP, mimeType, name, newMimeMsg, part, rawHeaders, regex, slashPos, type, typePart, _i, _j, _len, _len1, _ref, _ref1, _ref2;
            if (!bodyParts) {
                return;
            }
            for (_i = 0, _len = bodyParts.length; _i < _len; _i++) {
                part = bodyParts[_i];
                mimeType = ((_ref = part.mimeType) != null ? _ref : "").toLowerCase();
                if (mimeType.indexOf('multipart') !== -1) {
                    parseBodyParts(part.bodyParts);
                    continue;
                }
                if (mimeType.indexOf('message/rfc822') !== -1) {
                    newMimeMsg = MailParser(part.rawBody);
                    innerMsg = toMimeObj(newMimeMsg);
                    readyMail.innerMsgs.push(innerMsg);
                    continue;
                }
                rawHeaders = part.rawHeaders;
                isAttach = rawHeaders.indexOf('Content-Disposition: attachment') !== -1;
                body = part.rawBody;
                isHtml = /text\/html/.test(mimeType);
                isPlain = /text\/plain/.test(mimeType);
                isImg = /image/.test(mimeType);
                isAudio = /audio/.test(mimeType);
                if (isAttach || isImg || isAudio) {
                    isQP = /Content-Transfer-Encoding: quoted-printable/i.test(rawHeaders);
                    if (isQP) {
                        body = _util.QPDec(body);
                        body = btoa ? btoa(body) : Base64.encode(body);
                    }
                    _ref1 = part.contentTypeParts;
                    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                        typePart = _ref1[_j];
                        if (/name=/i.test(typePart)) {
                            name = typePart.replace(/(.*)=/, '').replace(/"|'/g, '');
                            break;
                        }
                    }
                    if (!name) {
                        name = isImg ? "image" : isAudio ? "audio" : "attachment";
                        name += "_" + Math.floor(Math.random() * 100);
                        slashPos = mimeType.indexOf('/');
                        type = mimeType.substring(slashPos + 1);
                        if (type.length < 4) {
                            name += "." + type;
                        }
                    }
                    regex = /(.*)content-id:(.*)<(.*)>/i;
                    attach = {
                        type: mimeType,
                        base64: body,
                        name: name,
                        cid: (_ref2 = regex.exec(rawHeaders)) != null ? _ref2[3] : void 0,
                        visible: /png|jpeg|jpg|gif/.test(mimeType)
                    };
                    readyMail.attaches.push(attach);
                } else if (isHtml || isPlain) {
                    body = decodeBody(body, rawHeaders);
                    body = _util.decode(body, part.contentType);
                    if (isHtml) {
                        readyMail.html += body;
                    }
                    if (isPlain) {
                        readyMail.text += body;
                    }
                } else {
                    console.log("Unknown mime type: " + mimeType);
                }
            }
            return null;
        };
        try {
            parts = rawMailObj.messageParts;
            if (!parts) {
                return readyMail;
            }
            mimeType = (parts.mimeType || "").toLowerCase();
            isText = /text\/plain/.test(mimeType);
            isHtml = /text\/html/.test(mimeType);
            if (mimeType.indexOf('multipart') !== -1) {
                parseBodyParts(parts.bodyParts);
            } else if (isText || isHtml) {
                body = decodeBody(parts.body, parts.rawHeaders);
                body = _util.decode(body, parts.contentType);
                if (isHtml) {
                    readyMail.html = body;
                }
                if (isText) {
                    readyMail.text = body;
                }
            } else {
                console.log("Warning: mime type isn't supported! mime=" + mimeType);
            }
        } catch (_error) {
            err = _error;
            throw new Error(err);
        }
        wrapPreTag = function (txt) {
            return "<pre>" + _util.toHtmlEntity(txt) + "</pre>";
        };
        mergeInnerMsgs = function (mail) {
            var htm, innerMsg, innerMsgs, msg, txt, _i, _len, _ref;
            innerMsgs = mail.innerMsgs;
            if (innerMsgs != null ? innerMsgs.length : void 0) {
                if (!_util.trim(mail.html) && mail.text) {
                    mail.html += wrapPreTag(mail.text);
                }
                for (_i = 0, _len = innerMsgs.length; _i < _len; _i++) {
                    innerMsg = innerMsgs[_i];
                    msg = mergeInnerMsgs(innerMsg);
                    txt = msg.text;
                    htm = msg.html;
                    if (htm) {
                        mail.html += htm;
                    } else if (txt) {
                        mail.html += wrapPerTag(txt);
                        mail.text += txt;
                    }
                    if (((_ref = msg.attaches) != null ? _ref.length : void 0) > 0) {
                        mail.attaches = mail.attaches.concat(msg.attaches);
                    }
                }
            }
            return mail;
        };
        result = mergeInnerMsgs(readyMail);
        return result;
    };
    toMimeObj = function (mimeMsgText) {
        var mailObj, rawMailObj;
        rawMailObj = MailParser(mimeMsgText);
        mailObj = buildMimeObj(rawMailObj);
        return mailObj;
    };
    return {
        toMimeTxt,
        toMimeObj,
    };
}()
